enum ObtainTypes {
  produced = 'produced',
  purchased = 'purchased',
  recycle_lost = 'recycle_lost',
  recycle_gained = 'recycle_gained',
}

export default ObtainTypes;
